import { types, flow, applySnapshot } from 'mobx-state-tree';
import { CommerceApi } from 'service/axios-api';

const Wallet = types
    .model('Wallet', {
        currency: types.optional(types.string, 'NX'),
        totalBalance: types.optional(types.number, 0),
        loading: types.optional(types.boolean, false),
    })
    .actions(self => ({
        fetch: flow(function*() {
            self.loading = true;

            const data: {
                currency: string;
                totalAmount: number;
            } = yield CommerceApi.get('/balance');

            let ssData = {
                currency: data.currency,
                totalBalance: data.totalAmount,
                loading: false,
            };
            applySnapshot(self, ssData);
        }),
    }));

export default Wallet;
